export const supplierGridProperties = {
  supplierName: 'supplierName',
  supplierEmail: 'supplierEmail',
  supplierAddress: 'addressLine1',
  supplierCountry: 'supplierCountry',
  contactName: 'contactName',
  contactPhone: 'contactPhone',
} as const;
